export default __webpack_public_path__ + "static/media/ic_cn_flag.7a35d7ff.svg";